import joi from 'joi';

import { deviceTypes } from '../nodes/constants';

export const hideableNodeTypes = [...deviceTypes, 'cloud', 'transit'] as const;
export type HideableNodeType = (typeof hideableNodeTypes)[number];
export const hideableNodeTypeSchema = joi.valid(...hideableNodeTypes);
